import { FC } from "react";
import { IconButton, Tooltip } from "@mui/material";
import { IconType } from "react-icons";
import styled from "styled-components";

const CustomIconButton = styled(IconButton)`
  && {
    width: 45px;
    height: 45px;
    display: flex;
    align-items: center;
    justify-content: center;

    svg {
      fill: rgb(202, 200, 200);
    }

    &.Mui-disabled {
      svg {
        fill: rgba(182, 182, 182, 0.253);
      }
    }

    &:hover {
      background: rgba(92, 92, 92, 0.573);
    }
  }
`;

interface IActionRowButtonProps {
  tooltip: string;
  Icon: IconType;
  handleClick: () => void;
  disabled?: boolean;
  iconSize?: number;
  children?: any;
  forceTooltip?: boolean;
}

const ActionRowButton = ({
  children,
  tooltip,
  handleClick,
  Icon,
  disabled = false,
  iconSize = 25,
  forceTooltip = false,
}: IActionRowButtonProps) => {
  return (
    <Tooltip title={tooltip} arrow open={forceTooltip ? true : undefined}>
      <span tabIndex={0}>
        <CustomIconButton
          disabled={disabled}
          onClick={handleClick}
        >
          <Icon size={iconSize} />
          {children}
        </CustomIconButton>
      </span>
    </Tooltip>
  );
};

export default ActionRowButton;
